import React from 'react';
import { makeStyles } from '@material-ui/core';
import MetaField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';


const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    padding: theme.spacing(0, 1),
  },
  attribute: {
    flex: '0 0 20%',
    wordBreak: 'break-all',
    position: 'relative',
  },
  meta: {
    paddingRight: theme.spacing(6),
  },
}));

const AumApexAccountLayout = () => {
  const classes = useStyles();
  const { resource } = useMetaLayoutContext();

  return (
    <div className={classes.root}>
      {resource.attr('accountNumber') ? (
        <div className={classes.attribute}>
          <MetaField
            className={classes.meta}
            attr="accountNumber"
          />
        </div>
      ) : null }
      {resource.attr('accountTitle') ? (
        <div className={classes.attribute}>
          <MetaField className={classes.meta} attr="accountTitle" />
        </div>
      ) : null }
      {resource.attr('createdAt') ? (
        <div className={classes.attribute}>
          <MetaField className={classes.meta} attr="createdAt" />
        </div>
      ) : null }
      {resource.attr('householdId') ? (
        <div className={classes.attribute}>
          <MetaField className={classes.meta} attr="householdId" />
        </div>
      ) : null }
      {resource.attr('acatInstructionCount') ? (
        <div className={classes.attribute}>
          <MetaField className={classes.meta} attr="acatInstructionCount" />
        </div>
      ) : null }
      {resource.attr('balance') ? (
        <div className={classes.attribute}>
          <MetaField className={classes.meta} attr="balance" />
        </div>
      ) : null }
      {resource.attr('openedDate') ? (
        <div className={classes.attribute}>
          <MetaField className={classes.meta} attr="openedDate" />
        </div>
      ) : null }
      {resource.attr('rolloverInstructionCount') ? (
        <div className={classes.attribute}>
          <MetaField className={classes.meta} attr="rolloverInstructionCount" />
        </div>
      ) : null }
      {resource.attr('achInstructionCount') ? (
        <div className={classes.attribute}>
          <MetaField className={classes.meta} attr="achInstructionCount" />
        </div>
      ) : null}
      {resource.attr('hasFundingInstructions') ? (
        <div className={classes.attribute}>
          <MetaField className={classes.meta} attr="hasFundingInstructions" />
        </div>
      ) : null }
      {resource.attr('accountType') ? (
        <div className={classes.attribute}>
          <MetaField className={classes.meta} attr="accountType" />
        </div>
      ) : null }
      {resource.attr('isOpen') ? (
        <div className={classes.attribute}>
          <MetaField className={classes.meta} attr="isOpen" />
        </div>
      ) : null }
    </div>
  );
};

export default AumApexAccountLayout;
